import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { TrendlineDto } from 'types';

export const getTrendline = async (
  snapshotId: number,
  interval: string
): Promise<TrendlineDto[]> => {
  const { data } = await axios.get(
    `/api/snapshots/${snapshotId}/trendline/${interval}`
  );
  return data as TrendlineDto[];
};

type QueryFnType = typeof getTrendline;

type UseTrendlineOptions = {
  snapshotId: number;
  interval: string;
  config?: QueryConfig<QueryFnType>;
};

export const useTrendline = ({
  snapshotId,
  interval,
  config,
}: UseTrendlineOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['snapshot', snapshotId, 'trendline', interval],
    queryFn: () => getTrendline(snapshotId, interval),
  });
};
